import React from "react";

const Convo = ({ lastMsgRef }) => {
    return (
        <div
            ref={lastMsgRef}
            style={{
                display: "flex",
                flexDirection: "column",
                gap: "12px",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
                color: "#64748b",
                textAlign: "center",
                padding: "16px",
            }}
        >
            <i className="fas fa-comments" style={{ fontSize: "32px", color: "#cbd5e1" }}></i>
            <p>No conversation selected</p>
        </div>
    );
};

export default Convo;
